import * as Scrivito from "scrivito";
import { createMultiselectComponent } from "utils";
import categoriesProducts from "config/locals/keysCategoriesProducts.json";
import {
  defaultPageEditingConfigAttributes,
  defaultPropertiesGroups,
  defaultPageInitialContent,
  defaultPageProperties,
} from "objs/_defaultPageEditingConfig";
import {
  metadataEditingConfigAttributes,
  metadataInitialContent,
  metadataPropertiesGroups,
} from "objs/_metadataEditingConfig";

Scrivito.provideEditingConfig("Document", {
  attributes: {
    ...defaultPageEditingConfigAttributes,
    ...metadataEditingConfigAttributes,
  },
  initialContent: {
    ...defaultPageInitialContent,
    ...metadataInitialContent,
  },
  properties: ["blob", "idNr", "categoryDownloadType", "fileTypeDe"],
  propertiesGroups: [
    {
      title: "Advanced",
      properties: [
        "sortKey",
        ...defaultPageProperties,
        "filegroupDe",
        "complementaryText",
        "categoryDocumentTypes",
      ],
    },
    {
      title: "Categories",
      component: createMultiselectComponent([
        {
          title: "Category series",
          attribute: "categorySeries",
          values: categoriesProducts.series,
        },
        {
          title: "Category groups",
          attribute: "categoryGroups",
          values: categoriesProducts.groups,
        },
        {
          title: "Category subsegments",
          attribute: "categorySubsegments",
          values: categoriesProducts.subsegments,
        },
        {
          title: "Category segments",
          attribute: "categorySegments",
          values: categoriesProducts.segments,
        },
      ]),
    },
    ...defaultPropertiesGroups,
    ...metadataPropertiesGroups,
  ],
});
